export default {
  asana: {
    label: 'Asana',
    value: 'asana',
    imageId: 'asana-logo.svg',
  },
  basecamp: {
    label: 'Basecamp',
    value: 'basecamp',
    imageId: 'basecamp-logo.svg',
  },
  monday: {
    label: 'Monday.com',
    value: 'monday',
    imageId: 'monday-logo.svg',
  },
  trello: {
    label: 'Trello',
    value: 'trello',
    imageId: 'trello-logo.svg',
  },
  wrike: {
    label: 'Wrike',
    value: 'wrike',
    imageId: 'wrike-logo.svg',
  },
};
